/**
 * One member of a family whose members differ only by the mark drawn in
 * them: the family's shared drawing, with that member's mark fixed, as a
 * glyph like any other.
 */import*as React from"react";import{jsx as _jsx}from"react/jsx-runtime";export default function markedGlyph(Drawing,mark){function MarkedFamilyGlyph(props){return/*#__PURE__*/_jsx(Drawing,{progress:props.progress,colors:props.colors,mark:mark});}return MarkedFamilyGlyph;}